import styled from "styled-components";
import { MainFrameWrapper } from "../../../components/01_config/MainStyles";
// import { MainFrameWrapper } from "../../../../../components/01_config/MainStyles";

const FrameWrapper = styled(MainFrameWrapper)`
`

export { FrameWrapper }
